export const lcmHealthPlanInitialValues = (health_plan) => ({
  name: health_plan?.name ?? "",
  auto_assignment: health_plan?.auto_assignment || false,
  status: health_plan?.status || "active",
});
